import { logError } from '@ptek/client-logger';
import { apiRouter } from '../config/api';
import { HealthStatus } from '../types/healthStatus';

export class HealthStatusClient {
  private async makeApiCall(
    endpoint: string,
    options: RequestInit = {}
  ): Promise<unknown> {
    return apiRouter.makeApiCall(endpoint, options);
  }

  async getHealthStatus(): Promise<HealthStatus> {
    try {
      const response = await this.makeApiCall('/api/v1/status', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response as HealthStatus;
    } catch (error) {
      logError('HealthStatusClient', 'Failed to get health status:', error);
      throw error;
    }
  }
}

export const healthStatusClient = new HealthStatusClient();
